import React from 'react';
import Button from 'components/common/Buttons/Button';
import ThreeppModal from 'components/common/Modal/Modal';

import './ConfirmationModal.scss';

const ConfirmationModal = props => {
  const { isOpen, title, message, cancelButtonText, confirmButtonText, onCancel, onConfirm } = props;

  return (
    <ThreeppModal isOpen={isOpen} toggle={onCancel} classes="confirmation-modal" header={title} size="sm">
      <div className="modal-message">{message}</div>

      <div className="action-row">
        <Button className="btn-cancel" buttonStyle="destructive" onClick={onCancel}>
          {cancelButtonText}
        </Button>

        <Button className="btn-submit" buttonStyle="primary" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </div>
    </ThreeppModal>
  );
};

export default ConfirmationModal;
